import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';
import Background from 'components/common/Background';
import corner4 from 'assets/img/illustrations/corner-4.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Input from 'components/common/Input';
import Flex from 'components/common/Flex';

const Amenities = ({ setValue, register, errors, select, setSelect }) => {
 const createOption = inputValue => {
  const newOption = { label: inputValue, value: inputValue };
  //console.log([...select?.amenities.map(e => e.value), inputValue], 'crear');
  setValue('amenities', [...select.amenities.map(e => e.value), inputValue]);
  setSelect(prev => ({ ...prev, options: [...prev.options, newOption] }));
 };

 return (
  <Card className="mb-3">
   <Background
    image={corner4}
    className="bg-card"
    style={{
     borderTopRightRadius: '0.375rem',
     borderBottomRightRadius: '0.375rem'
    }}
   />
   <Card.Body className="bg-100 fs--1">
    <Flex className="mb-3">
     <span className="fa-stack me-2 ms-n1 circle-dashed" style={{ width: '30px', height: '30px' }}>
      <FontAwesomeIcon icon="circle" className="fa-stack-2x text-300" />
      <FontAwesomeIcon icon="plus" className="fa-inverse fa-stack-1x text-primary" />
     </span>
     <div className="flex-1">
      <h5 className="mb-0 text-primary position-relative">
       <span className="bg-100 dark__bg-1100 pe-3">Amenidades</span>
       <span className="border position-absolute top-50 translate-middle-y w-100 start-0 z-index--1"></span>
      </h5>
      <p className="mb-0">
       Seleccione o cree las amenidades que desea ofrecer en el proyecto para hacerlo más atractivo y cómodo para los posibles
       compradores. Ofrecer servicios exclusivos y una amplia variedad de opciones es una excelente manera de diferenciarse de la
       competencia y atraer a un público más amplio.
      </p>
     </div>
    </Flex>
    <Input
     type="selectMulti"
     name="amenities"
     errors={errors}
     placeholder="Select..."
     options={select?.options}
     formGroupProps={{
      className: 'flex-fill mb-3'
     }}
     formControlProps={{
      ...register('amenities', { required: 'Debe especificar las amenidades del proyecto' }),
      isClearable: true,
      isMulti: true,
      closeMenuOnSelect: false,
      onChange: newValue => {
       //setSelect(prev => ({ ...prev, amenities: newValue }));

       setValue('amenities', newValue.map(e => e.value) || []);
      },
      onCreateOption: createOption,
      value: select?.amenities
     }}
    />
   </Card.Body>
  </Card>
 );
};

Amenities.propTypes = {
 setValue: PropTypes.func,
 register: PropTypes.func,
 errors: PropTypes.object,
 select: PropTypes.object,
 setSelect: PropTypes.func
};

export default Amenities;
